import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";

import Fire from "./fire";

const fire = new Fire();
const firestore = fire.firestore;

export interface FirestoreData {
  products: RawProduct[];
}

export interface RawProduct {
  step: string;
  product_url: string;
  haravan_product_id: string;
  categories: string[];
  name: string;
  description: string;
  image_url: string;
}

const QUIZ_COLLECTION = "quiz";

export default class MyRoutineFirestore {
  private ref: firebase.firestore.DocumentReference<
    firebase.firestore.DocumentData
  >;

  constructor() {
    this.ref = firestore.collection(QUIZ_COLLECTION).doc("my_routine");
  }

  public async getProducts(): Promise<RawProduct[]> {
    const doc = await this.ref.get();
    const data = doc.data() as FirestoreData;
    return data.products;
  }

  public updateProducts(products: RawProduct[]) {
    return this.ref.update({ products });
  }
}
